import { API_ABONADOS_URL } from '../data/GlobalConstants';

export async function updateLastConnection(idBetis) {
    if (!API_ABONADOS_URL || !idBetis) {
        return false;
    }

    try {
        const response = await fetch(`${API_ABONADOS_URL}/api/rbb/auth/last-connection/${encodeURIComponent(idBetis)}`, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json',
            },
        });

        if (!response.ok) {
            console.error(`Error actualizando ultima conexión para idBetis ${idBetis}: ${response.statusText}`);
            return false;
        }

        return true;
    } catch (e) {
        console.error(`Error actualizando ultima para idBetis ${idBetis}: ${e.message}`);
        return false;
    }
}